module.exports = __webpack_public_path__ + "img/bg6.db5228de.jpg";